var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilePpt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CC1D1D",
  d: "M3.994 4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.994 2 6 6h-4a2 2 0 0 1-2-2z",
  opacity: 0.25
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.553 15.37v-.643h2.766v.642h-.992V18h-.78v-2.63zM10.727 18v-3.273h1.352q.367 0 .634.143.27.143.414.398.146.255.146.592 0 .338-.15.593a1 1 0 0 1-.42.391q-.273.14-.648.14h-.835v-.624h.688q.179 0 .299-.062a.43.43 0 0 0 .183-.175.54.54 0 0 0 .063-.263.5.5 0 0 0-.063-.262.4.4 0 0 0-.184-.173.7.7 0 0 0-.298-.06h-.39V18zM7.79 18v-3.273H9.14q.368 0 .635.143.269.143.414.398t.145.592q0 .338-.149.593a1 1 0 0 1-.42.391q-.273.14-.649.14h-.834v-.624h.687q.18 0 .299-.062a.43.43 0 0 0 .184-.175.54.54 0 0 0 .062-.263.5.5 0 0 0-.062-.262.4.4 0 0 0-.184-.173.7.7 0 0 0-.299-.06h-.39V18z"
})));
export default SvgFilePpt;